var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,32c-1.9855347,0-3.7435913,0.9733887-4.8363037,2.4636841L15.737915,25.7507935 C15.9073486,25.1965332,16,24.6090088,16,24s-0.0926514-1.1965332-0.262085-1.7507935l17.4257812-8.7128906 C34.2564087,15.0266113,36.0144653,16,38,16c3.3085938,0,6-2.6914062,6-6s-2.6914062-6-6-6s-6,2.6914062-6,6 c0,0.6090088,0.0926514,1.1965332,0.262085,1.7507935l-17.4257812,8.7128906C13.7435913,18.9733887,11.9855347,18,10,18 c-3.3085938,0-6,2.6914062-6,6s2.6914062,6,6,6c1.9855347,0,3.7435913-0.9733887,4.8363037-2.4636841l17.4257812,8.7128906 C32.0926514,36.8034668,32,37.3909912,32,38c0,3.3085938,2.6914062,6,6,6s6-2.6914062,6-6S41.3085938,32,38,32z M34,10 c0-2.2060547,1.7939453-4,4-4s4,1.7939453,4,4s-1.7939453,4-4,4S34,12.2060547,34,10z M10,28c-2.2060547,0-4-1.7939453-4-4 s1.7939453-4,4-4s4,1.7939453,4,4S12.2060547,28,10,28z M38,42c-2.2060547,0-4-1.7939453-4-4s1.7939453-4,4-4s4,1.7939453,4,4 S40.2060547,42,38,42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMedium);
export default __webpack_public_path__ + "static/media/share--medium.0fa7e1a6084adf10c2011f4c5f00ed82.svg";
export { ForwardRef as ReactComponent };